//core
import React from 'react';
import arePropsEqual from "react-fast-compare";
import { Chip } from "@mui/material";

//theme
import { Theme } from "@mui/material/styles/createTheme";
import { useTheme } from "@mui/styles";


interface ILevel {
  value: number;
  backgroundColor?: string;
}

const Level = ({value, backgroundColor}: ILevel) => {
  const theme: Theme = useTheme();

  return (
    <>
      <Chip
        size="small"
        label={value === null ? '—' : `${value}`}
        color="secondary"
        sx={{
          backgroundColor: backgroundColor || theme.palette.grey[300],
          borderRadius: '4px',
          color: theme.palette.text.primary
        }}
      />
    </>
  );
};

export default React.memo(Level, arePropsEqual)
